import { ClinicalCaseWithRelations } from 'src/app/sdk-api';

export namespace ClinicalCaseState {
  export const key = 'clinicalCase';

  export interface State {
    clinicalCase: ClinicalCaseWithRelations;
  }

  export const initialState: State = {
    clinicalCase: null,
  };
}
